import script from "./LandingFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingFooter.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__